<template>
  <el-card class="box-card">
    <el-row>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="1" style="padding:30px;">
            <h3 >Vous n'avez toujours pas défini votre inventaire?</h3>
            <p >Créer dès aujourd'hui un inventaire pour commencer à vendre vos produits et générer des revenus!</p>
            <el-button type="primary" @click="createNewInventory">Créer un inventaire</el-button>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="1">
              <img class="inventory" src="/static/images/inventory/inventory-magementx200.png">
        </el-col>
    </el-row>
  </el-card>
</template>
<script>
import axios from "axios"

export default {
  data() {
    return {
    };
  },components: {

  },
	methods: {
    createNewInventory(){
      this.$emit('createNewInventory');
    }
	},
	computed: {

	}
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
